import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DynamicModalFormComponent} from "../../../common/dynamic-modal-form/dynamic-modal-form.component";
import {
    UserRequestComparatorComponent
} from "../../../common/user-request-comparator/user-request-comparator.component";
import {UserRequestDetailComponent} from "../user-request-detail/user-request-detail.component";
import {UserRequest} from "../../../../model/UserRequest";
import {FaqCategory} from "../../../../model/FaqCategory";

@Component({
    selector: 'app-user-requests-view',
    imports: [
        DynamicModalFormComponent,
        UserRequestComparatorComponent,
        UserRequestDetailComponent
    ],
    templateUrl: './user-requests-view.component.html',
    styleUrl: './user-requests-view.component.scss'
})
export class UserRequestsViewComponent {
  @Input()
  request: UserRequest;
  @Input()
  categories: FaqCategory[] = [];
  @Input()
  crmUrl: string;
  @Output()
  cancel = new EventEmitter();

  onCancel() {
    this.cancel.emit();
  }
}
